(function(){

  'use strict'

  angular
    .module('app', [
      'ngAnimate',
      'aloengular'
    ])
  ;

})();
